import React from 'react';
import styled from 'styled-components';

export interface EmptyBlocProps {
  filetitle: string;
  fileText: string;
}

const SvgContainer = styled.div`
  &&.svgContainer {
    height: 120px;
    width: 120px;
    border-radius: 100%;
    background: rgb(247, 247, 247);
    background: linear-gradient(
      0deg,
      rgba(247, 247, 247, 1) 0%,
      rgba(226, 226, 224, 1) 40%
    );
    vertical-align: middle;
    padding: 20px;
    margin: 48px auto 32px;
  }
`;
const NoValidateFileTitle = styled.div`
  &&.noValidateFileTitle {
    text-align: center;
    font-size: 19px;
    font-weight: bold;
    letter-spacing: 0;
    color: #202124;
    opacity: 1;
    margin: 0;
  }
`;
const NoValidateFileText = styled.div`
  &&.noValidateFileText {
    text-align: center;
    font-size: 16px;
    letter-spacing: 0;
    color: #666666;
    opacity: 1;
    margin: 0;
  }
`;
const EmptyBloc: React.FC<EmptyBlocProps> = (props): JSX.Element => {
  return (
    <div>
      <SvgContainer className="svgContainer">{props.children}</SvgContainer>
      <NoValidateFileTitle className="noValidateFileTitle">
        {props.filetitle}
      </NoValidateFileTitle>
      <NoValidateFileText className="noValidateFileText">
        {props.fileText}
      </NoValidateFileText>
    </div>
  );
};
export default EmptyBloc;
